import L from 'leaflet';

function metersToDegrees(meters) {
  // this is approximate (spherical earth, average circumference, not considering altitude, etc.)
  const earth = 40075000; // average circumference in metres at sea level
  return (meters * 360.0) / earth;
}

function coordinatesToPoints(coordinates) {
  return coordinates.map(coord => ({ x: coord.lng, y: coord.lat }));
}

function pointsToCoordinates(points) {
  return points.map(pt => ({ lng: pt.x, lat: pt.y }));
}

function simplify(coordinates, tolerance) {
  const points = coordinatesToPoints(coordinates);
  const epsilon = metersToDegrees(tolerance || 2);
  const simplifiedPoints = L.LineUtil.simplify(points, epsilon);
  return pointsToCoordinates(simplifiedPoints);
}

export default simplify;
